class PersistorImpl {
  setItem = <VALUE,>(key: string, value: VALUE): void => {
    sessionStorage.setItem(key, JSON.stringify(value));
  };
  getItem = <VALUE,>(key: string): VALUE | null => {
    const value = sessionStorage.getItem(key);
    return value ? (JSON.parse(value) as VALUE) : null;
  };
  removeItem = (key: string): void => {
    sessionStorage.removeItem(key);
  };
  clear = (): void => {
    sessionStorage.clear();
  };
}

export const Persistor = new PersistorImpl();
